import {useSelector} from "react-redux";
import {selectWorkspaces} from "joynt/state/selectors/joint";

export function useWorkspaces(parent) {
    return useSelector(s => selectWorkspaces(s, parent));
}